import {HttpClient} from "@angular/common/http";
import {StandaloneRemoteExtraFeeService} from "./standalone-extra-fee.service";
import {RemoteExtraFeeService} from "./remote-extra-fee.service";
import {StandaloneModeService} from "../../standalone-mode.service";
import {SqliteExtraFeeRepository} from "../../sqllite/repositories/params/sqlite-extra-fee.repository";
import {ParametersDatabase} from "../../sqllite/databases/parameters.database";

export const extraFeeServiceFactory = (standaloneModeService: StandaloneModeService, parametersDatabase: ParametersDatabase, httpClient: HttpClient) => {
    return standaloneModeService.isOffline() ? new StandaloneRemoteExtraFeeService(new SqliteExtraFeeRepository(parametersDatabase)) : new RemoteExtraFeeService(httpClient);
};